import { NgModule } from '@angular/core'
import { NodeTypeListComponent } from './node-type-list.component'
import { CommonModule } from '@angular/common'
import { NodeListItemModule } from '../node-list-item/node-list-item.module'

@NgModule({
  imports: [CommonModule, NodeListItemModule],
  exports: [NodeTypeListComponent],
  declarations: [NodeTypeListComponent]
})
export class NodeTypeListModule {}
